document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".sb-add-upsells");
  if (!btn) return;

  btn.addEventListener("click", function () {
    const variants = document.querySelectorAll(".sb-upsell-variant");

    let items = [];
    variants.forEach(v => {
      items.push({
        id: v.value,
        quantity: 1
      });
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items })
    })
    .then(() => {
      window.location.href = "/cart";
    });
  });
});